import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISidebarSeparatorProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useSidebarRootContext
} from "../../context";

const SidebarSeparator: FC<ISidebarSeparatorProps> = ({
    customTheme: customThemeProp,
    style,
    ...props
}) => {
    const root = useSidebarRootContext({
        part: "Sidebar.Separator"
    });

    const customTheme = customThemeProp ?? root?.customTheme;

    const {
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        borders,
        colors,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        role="separator"
    />;
};
export default SidebarSeparator;
